import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormArray,
  Validators,
  FormControl
} from "@angular/forms";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { ActivatedRoute, Params } from "@angular/router";

import { environment } from "../../../../environments/environment";
import { CrudService } from "../../../crud/crud.service";
import { NotificationsService } from 'angular2-notifications';

import { Mensaje } from "../../../mensaje";

import jsPDF from 'jspdf'; import autoTable from 'jspdf-autotable'; import * as jQuery from 'jquery';
import * as moment from 'moment';


@Component({
  selector: "app-calificacion-grupo",
  templateUrl: "./formulario.component.html"
})
export class CalificacionGrupoComponent implements OnInit {
  dato = [];
  periodo_escolar;
  carrera_plan;
  profesor;
  cargando = false;
  borrarCargando = false;
  baja: boolean = true
  ultima_actualizacion: any;
  ultima_actualizacion_fecha;
  ultima_actualizacion_hora;
  mensajeResponse: Mensaje = new Mensaje(true);
  public options = {
    position: ["middle", "center"],
    timeOut: 3000,
    lastOnBottom: true
  };
  time_cal;

  empresa = localStorage.getItem("empresa");
  sucursal = localStorage.getItem("sucursal");

  tieneid: boolean = false;

  configuracion = JSON.parse(localStorage.getItem("configuracion"));
  usuario = JSON.parse(localStorage.getItem("usuario"));

  grupo = null;
  materia = '';
  materias = null;
  constructor(
    private crudService: CrudService,
    private route: ActivatedRoute,
    private _sanitizer: DomSanitizer,
    private notificacion: NotificationsService
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      if (params["id"]) {
        this.tieneid = true;
      }
    });
    document.getElementById("catalogos").click();
  }

  cargarDatos(materia, periodo_escolar, profesor, grupo) {
    moment.locale("es-mx");

    if (materia.hasOwnProperty("value")) {
      this.materia = materia.value;
    } else {
      this.materia = materia;
    }

    this.dato = [];
    this.grupo = null;
    this.carrera_plan = null;
    this.cargando = true;
    let param = {
      periodo: periodo_escolar,
      profesor: profesor,
      grupo: grupo
    };

    this.crudService.ver(materia, "calificacion-grupo", param).subscribe(
      resultado => {
        if (resultado.status == 200) {
          this.dato = resultado.data;
          this.ultima_actualizacion = resultado.ultima_actualizacion ? resultado.ultima_actualizacion.date ? resultado.ultima_actualizacion.date : '' : '';
          this.ultima_actualizacion_fecha = this.ultima_actualizacion ? moment(this.ultima_actualizacion).format('LL') : '';
          this.ultima_actualizacion_hora = this.ultima_actualizacion ? moment(this.ultima_actualizacion).format('LTS') : '';
          this.grupo = resultado.grupo;
          this.materias = resultado.materia;
          this.profesor = resultado.profesor;
          this.carrera_plan = resultado.carrera_plan;
          document.getElementById("CaragarLogos").click();
        } else {
          this.mensajeResponse.titulo = "No configurado";
          this.mensajeResponse.texto = "No se encontro datos";
          this.mensajeResponse.clase = "warning";
          this.mensaje(3);
        }
        this.cargando = false;
      },
      error => {
        this.cargando = false;
        this.cargando = false;
        this.mensajeResponse.titulo = "Error";
        this.mensajeResponse.texto = "Algo salio mal";
        this.mensajeResponse.clase = "danger";
        this.mensaje(3);
      }
    );
  }

  enviar() {
    this.cargando = true;
    document
      .getElementById("confirmarCalificacion")
      .classList.remove("is-active");
    this.crudService.crear(this.dato, "calificacion-grupo").subscribe(
      resultado => {
        this.cargando = false;
        if (resultado.status == 200 || resultado.status == 201) {
          this.mensajeResponse.titulo = "Guardado";
          this.mensajeResponse.texto = "Se ha guardado correctamente";
          this.mensajeResponse.clase = "success";
          this.mensaje(3);
        } else {
          this.mensajeResponse.titulo = "No guardado";
          this.mensajeResponse.texto = "NO se ha guardado";
          this.mensajeResponse.clase = "warning";
          this.mensaje(3);
        }
      },
      error => {
        this.cargando = false;
        this.mensajeResponse.titulo = "Error";
        this.mensajeResponse.texto = "Ocurrio un error inesperado ";
        this.mensajeResponse.clase = "danger";
        this.mensaje(3);
      }
    );
  }

  validar_max(event, modelo, max) {
    if (
      event.key != "Tab" &&
      event.key != "CapsLock" &&
      event.key != "Shift" &&
      event.key != "ArrowLeft" &&
      event.key != "ArrowRight" &&
      event.key != "ArrowUp" &&
      event.key != "ArrowDown" &&
      event.key != "."
    ) {
      clearTimeout(this.time_cal);
      this.time_cal = setTimeout(() => {
        if (modelo > max) {
          event.srcElement.value = max;
          modelo = max;
          this.mensajeResponse.titulo = "Maximo";
          this.mensajeResponse.texto =
            "El maximo valor para las calificaciones de este nivel es: " + max;
          this.mensajeResponse.clase = "warning";
          this.mensaje(3);
        }
      }, 500);
    }
  }
  mensaje(
    cuentaAtras: number = 6,
    posicion: any[] = ["middle", "center"]
  ): void {
    let objeto = {
      showProgressBar: true,
      pauseOnHover: true,
      clickToClose: true,
      maxLength: this.mensajeResponse.texto.length
    };

    this.options = {
      position: posicion,
      timeOut: cuentaAtras * 1000,
      lastOnBottom: true
    };

    if (this.mensajeResponse.clase == "alert")
      this.notificacion.alert(
        this.mensajeResponse.titulo,
        this.mensajeResponse.texto,
        objeto
      );

    if (this.mensajeResponse.clase == "success")
      this.notificacion.success(
        this.mensajeResponse.titulo,
        this.mensajeResponse.texto,
        objeto
      );

    if (this.mensajeResponse.clase == "info")
      this.notificacion.info(
        this.mensajeResponse.titulo,
        this.mensajeResponse.texto,
        objeto
      );

    if (
      this.mensajeResponse.clase == "warning" ||
      this.mensajeResponse.clase == "warn"
    )
      this.notificacion.warn(
        this.mensajeResponse.titulo,
        this.mensajeResponse.texto,
        objeto
      );

    if (
      this.mensajeResponse.clase == "error" ||
      this.mensajeResponse.clase == "danger"
    )
      this.notificacion.error(
        this.mensajeResponse.titulo,
        this.mensajeResponse.texto,
        objeto
      );
  }

  logo_sucursal;
  logo_empresa;
  logo_carrera;

  imprimirCalificacion(calif) {
    // console.log("aqui ando");
    moment.locale("es-mx");
    let conteo = 0;
    let doc = new jsPDF('portrait', 'mm', 'letter');

    doc.setLineWidth(0.1);
    doc.setDrawColor(1, 1, 1);
    doc.setFillColor(255, 255, 255);
    doc.setFont("helvetica");

    let logo = this.logo_sucursal != '' ? this.logo_sucursal : this.logo_empresa;
    if (logo != '' && logo != undefined && logo != null)
      doc.addImage('data:image/png;base64,' + logo, "PNG", 7, 5, 20, 20, "left", "FAST");

    if (this.logo_carrera != '')
      doc.addImage('data:image/png;base64,' + this.logo_carrera, "PNG", 180, 5, 20, 20, "right", "FAST");
    //Nombre empresa
    doc.setFontSize(15);
    doc.setFont("helvetica", "", "bold");
    doc.setFont("helvetica");
    doc.text(this.configuracion.empresa.nombre, 108, 12, { align: "center" });

    doc.setFontSize(14);
    doc.setFont("helvetica", "", "bold");
    doc.text(this.configuracion.empresa.subnombre, 108, 18, { align: "center" });

    doc.setFontSize(10);
    doc.setFont("helvetica", "", "normal");
    doc.text('Campus: ' + this.configuracion.sucursal.nombre, 110, 22, { align: 'center' });

    doc.setFontSize(10);
    doc.setFont("helvetica", "", "bold");
    doc.text('ACTA DE EVALUACIÓN', 110, 28, { align: 'center' });

    doc.setFontSize(8);
    doc.setFont("helvetica", "", "bold");

    doc.text("CARRERA: " + this.carrera_plan.planes_estudios.nombre + ' - ' + this.carrera_plan.carreras.nombre, 10, 34, { align: "left" });
    doc.text(this.grupo.periodos_escolares.tipos_periodos.nombre_para_mostrar + ': ' + this.grupo.nivel, 10, 38, { align: 'left' });
    doc.text("MATERIA: ", 10, 42, { align: "left", maxWidth: 70 });
    doc.text(this.materias.nombre, 25, 42, { align: "left", maxWidth: 105 });

    doc.text("GRUPO: " + this.grupo.clave + ' ' + this.grupo.nivel + ' ' + this.grupo.identificador, 140, 38, { align: "left" });
    doc.text("TURNO: " + this.grupo.turnos.nombre, 140, 42, { align: "left" });


    // let columns = [
    //   { title: "     ", dataKey: "id" },
    //   { title: "                                                                ", dataKey: "alumno" }
    // ];
    conteo = 1;
    //console.log(this.configuracion.nivel_educativo.nombre);
    if (this.configuracion.nivel_educativo.nombre != 'Postgrados') {
      this.dato[0].calificaciones.forEach(par => {
        doc.line(10, 54, 206, 54) //linea superior
        doc.line(10, 54, 10, 60) // primera linea
        doc.line(23, 54, 23, 60)
        doc.line(123, 54, 123, 60)
        doc.line(206, 54, 206, 60)//ultimo linea
        doc.line(10, 60, 206, 60)//linea inferior

        // doc.line(110,54,110,60)
        let division = 83 / this.dato[0].calificaciones.length;
        doc.line(123 + (division * conteo), 54, 123 + (division * conteo), 60);
        doc.setFontSize(8);
        doc.setFont('helvetica', 'bold');
        if (division > 28) {
          doc.text('Parcial ' + conteo, 85 + (division * conteo), 58, { align: 'center' })
        } else {
          doc.text('Parcial ' + conteo, 110 + (division * conteo), 58, { align: 'center' })
        }
        conteo++;
      });
    }

    let columns = [
      { title: "N", dataKey: "id" },
      { title: "Nombre del alumno", dataKey: "alumno" }
    ];
    conteo = 1;
    this.dato[0].calificaciones.forEach(par => {
      columns.push({
        title: "Calf",
        dataKey: "parcial" + conteo
      });
      columns.push({
        title: "F ",
        dataKey: "falta" + conteo
      });
      conteo++;
    });

    let rows = [];
    let linea = 1;
    //let conteop = 1;
    for (let index = 0; index < this.dato.length; index++) {
      const element = this.dato[index];

      //console.log(element);
      if (this.baja == false) {
        if (element.baja == 0) {
          rows.push(
            {
              "id": linea,
              "alumno": element.alumno.nombre
            }
          )
          conteo = 1
          element.calificaciones.forEach(par => {
            rows[linea - 1]["parcial" + conteo] = calif ? par.calificacion ? par.calificacion : '--' : '';
            conteo++;
          });
          linea++
        }
      } else {
        rows.push(
          {
            "id": linea,
            "alumno": element.alumno.nombre
          }
        )
        conteo = 1
        element.calificaciones.forEach(par => {
          rows[linea - 1]["parcial" + conteo] = calif ? par.calificacion ? par.calificacion : '--' : '';
          conteo++;
        });
        linea++
      }


    }

    // this.dato.forEach(par => {
    //   if (this.baja != true) {
    //     if (par.baja != 1) {
    //       rows.push({
    //         id: linea,
    //         alumno: par.alumno.nombre,
    //       });

    //       conteo = 1;
    //       this.dato[linea - 1].calificaciones.forEach(par => {
    //         rows[linea - 1]["parcial" + conteo] = calif ? par.calificacion ? par.calificacion : '--' : '';
    //         rows[linea - 1]["falta" + conteo] = '';
    //         conteo++;
    //       });
    //       linea++;
    //     }
    //   }else{
    //     rows.push({
    //       id: linea,
    //       alumno: par.alumno.nombre,
    //     });

    //     conteo = 1;
    //     this.dato[linea - 1].calificaciones.forEach(par => {
    //       rows[linea - 1]["parcial" + conteo] = calif ? par.calificacion ? par.calificacion : '--' : '';
    //       rows[linea - 1]["falta" + conteo] = '';
    //       conteo++;
    //     });
    //     linea++;
    //   }

    // });

    (doc as any).autoTable({
      columns: columns,
      body: rows,
      didParseCell: function (cell, data) {
        //cell.styles.fillColor = "#ffffff";
      },
      startY: 60,
      styles: {
        fontSize: 8, font: "helvetica",
        halign: "center",
        fillColor: "#FFFFFF",
        textColor: "#000000",
        lineColor: "#000000",
        lineWidth: 0.1,
      },
      bodyStyles: {
        cellPadding: 0.8
      },
      headStyles: {
        lineColor: "#000000",
        lineWidth: 0.1
      },
      theme: "grid",
      margin: { right: 10, left: 10 },
      columnStyles: {
        id: { cellWidth: 13 },
        alumno: {
          cellWidth: 100,
          halign: "left"
        }
      }
    });

    // console.log(doc.lastAutoTable.finalY);

    doc.text(this.profesor.nombre, 50, 260, { align: "center" });
    doc.line(10, 265, 90, 265);
    doc.text("DOCENTE", 50, 270, { align: "center" });

    doc.line(120, 260, 200, 260);
    doc.text("VO. BO.", 160, 265, { align: "center" });
    doc.text("SERVICIOS ESCOLARES. ", 160, 270, { align: "center" });
    if (calif == true) {
      doc.setFontSize(10);
      doc.setFont("helvetica", "", "bold");
      doc.text("Ultima actualización de calificaciones el " + moment(this.ultima_actualizacion).format('LL') + " a las " + moment(this.ultima_actualizacion).format('LTS'), 10, doc.lastAutoTable.finalY + 10)
    }
    // doc.autoPrint();
    //const string = (doc as any).output('datauristring', 'horario_docente.pdf');
    window.open((doc as any).output('bloburl'), '_blank');
    /*const iframe = "<iframe border='0' style='border:0px' width='100%' height='100%' src='" + string + "'></iframe>"

    const x = window.open();
    x.document.open();
    x.document.write(iframe);
    x.document.close();*/

  }

  imprimirLista() {
    let doc = new jsPDF("p", "mm", "letter");

    doc.setLineWidth(0.1);
    doc.setDrawColor(1, 1, 1);
    doc.setFillColor(255, 255, 255);
    doc.setFont("helvetica");

    let logo = this.logo_sucursal != '' ? this.logo_sucursal : this.logo_empresa;
    if (logo != '' && logo != undefined && logo != null)
      doc.addImage('data:image/png;base64,' + logo, "PNG", 7, 5, 20, 20, "left", "FAST");

    if (this.logo_carrera != '')
      doc.addImage('data:image/png;base64,' + this.logo_carrera, "PNG", 180, 5, 20, 20, "right", "FAST");
    //Nombre empresa
    doc.setFontSize(15);
    doc.setFont("helvetica", "", "bold");
    doc.setFont("helvetica");
    doc.text(this.configuracion.empresa.nombre, 108, 12, { align: "center" });

    doc.setFontSize(14);
    doc.setFont("helvetica", "", "bold");
    doc.text(this.configuracion.empresa.subnombre, 108, 18, { align: "center" });

    doc.setFontSize(10);
    doc.setFont("helvetica", "", "normal");
    doc.text('Campus: ' + this.configuracion.sucursal.nombre, 110, 24, { align: 'center' });

    doc.setFontSize(10);
    doc.setFont("helvetica", "", "bold");
    doc.text("LISTA DE ASISTENCIA", 110, 30, { align: "center" });

    doc.setFontSize(8);
    doc.setFont("helvetica", "", "bold");

    doc.text("CARRERA: " + this.carrera_plan.planes_estudios.nombre + ' - ' + this.carrera_plan.carreras.nombre, 10, 40, { align: "left" });
    doc.text(this.grupo.periodos_escolares.tipos_periodos.nombre_para_mostrar + ': ' + this.grupo.nivel, 10, 45, { align: 'left' });
    doc.text("MATERIA: " + this.materias.nombre, 10, 50, { align: "left", maxWidth: 105});


    doc.text("GRUPO: " + this.grupo.clave + ' ' + this.grupo.nivel + ' ' + this.grupo.identificador, 140, 45, { align: "left" });
    doc.text("TURNO: " + this.grupo.turnos.nombre, 140, 50, { align: "left" });

    let columns = [
      { title: "N", dataKey: "id" },
      { title: "Nombre del alumno", dataKey: "alumno" }
    ];
    let dias = 20;
    if (this.grupo.periodos_escolares.modalidades.modalidades_dias.length < 3)
      dias = 4;

    if (this.grupo.periodos_escolares.modalidades.modalidades_dias.length == 3)
      dias = 12;

    let tamano = dias / this.grupo.periodos_escolares.modalidades.modalidades_dias.length;
    let conteo = 1;
    for (let i = 0; i < tamano; i++) {
      this.grupo.periodos_escolares.modalidades.modalidades_dias.forEach(par => {
        columns.push({
          title: par.dias_semanas.nombre.substr(0, 1).toUpperCase(),
          dataKey: "dia" + conteo
        });
        conteo++;
      });
    }

    let rows = []; let linea = 1;
    this.dato.forEach(par => {
      if (this.baja != true) {
        if (par.baja != 1) {
          rows.push({
            id: linea,
            alumno: par.alumno.nombre,
          });

          conteo = 1;
          for (let i = 0; i < tamano; i++) {
            this.grupo.periodos_escolares.modalidades.modalidades_dias.forEach(par => {
              rows[linea - 1]["dia" + conteo] = '';
              conteo++;
            });
          }

          linea++;
        }
      } else {
        rows.push({
          id: linea,
          alumno: par.alumno.nombre,
        });

        conteo = 1;
        for (let i = 0; i < tamano; i++) {
          this.grupo.periodos_escolares.modalidades.modalidades_dias.forEach(par => {
            rows[linea - 1]["dia" + conteo] = '';
            conteo++;
          });
        }

        linea++;
      }


    });

    (doc as any).autoTable({
      columns: columns,
      body: rows,
      didParseCell: function (cell) {
        let data = cell;
        cell = cell.cell;
        cell.styles.fillColor = "#ffffff";
      },
      startY: 62,
      styles: {
        fontSize: 7, font: "helvetica",
        halign: "center",
        fillColor: "#FFFFFF",
        textColor: "#000000",
        lineColor: "#000000",
        lineWidth: 0.1
      },
      headStyles: {
        lineColor: "#000000",
        lineWidth: 0.1
      },
      bodyStyles: {
        cellPadding: 0.8
      },
      theme: "grid",
      margin: { right: 10, left: 10 },
      columnStyles: {
        0: { cellWidth: 20 },
        1: { cellWidth: 60 },
        alumno: {
          halign: "left"
        }
      }
    });

    // doc.autoPrint();
    //const string = (doc as any).output('datauristring', 'horario_docente.pdf');
    window.open((doc as any).output('bloburl'), '_blank');
    /*const iframe = "<iframe border='0' style='border:0px' width='100%' height='100%' src='" + string + "'></iframe>"

    const x = window.open();
    x.document.open();
    x.document.write(iframe);
    x.document.close();*/

  }
  asignarLogos(logos) {
    if (logos) {
      this.logo_sucursal = logos.sucursal;
      this.logo_empresa = logos.empresa;
      this.logo_carrera = logos.carrera;
    }
  }
}
